// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 500,
      padding: theme.spacing(2),
    },
    itemText: {
      textTransform: 'uppercase',
    },
    buttons: {
      justifyContent: 'space-between',
      padding: 20,
    },
  }),
);

export default useStyles;
